import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getQueryParam } from '../../../../helpers/url/urlHelpers';
import ITSearchReducer from '../../../../interfaces/search/searchReducer';
import { IStore } from '../../../../reducers';
import Pagination from './pagination';
import PlaceHolderLoader from './placeholderLoader/index';
import ResultItem from './resultItem';
import * as StyledSearchResults from './searchResults.styles';

const SearchResults: FC = () => {
	const { t } = useTranslation('search');
	const query = getQueryParam('q');
	const searchReducer: ITSearchReducer = useSelector<IStore, ITSearchReducer>(store => store.searchReducer);
	const { searchLoading, searchResults } = searchReducer;
	const [activeResultGroup, setActiveResultgroup] = useState(0);

	useEffect(() => {
		if (searchLoading) {
			setActiveResultgroup(0);
		}
	}, [searchLoading]);

	return (
		<StyledSearchResults.Wrapper>
			{searchLoading && query && (
				<StyledSearchResults.ResultsWrapper>
					<PlaceHolderLoader />
				</StyledSearchResults.ResultsWrapper>
			)}
			{!searchLoading && searchResults && (
				<>
					<StyledSearchResults.ResultsWrapper>
						<StyledSearchResults.ResultCount>
							{t('number-of-results')}
							<StyledSearchResults.ResultCountNumber>
								{` ${searchResults.resultsNumber}`}
							</StyledSearchResults.ResultCountNumber>
						</StyledSearchResults.ResultCount>
						<StyledSearchResults.ResultItems>
							{searchResults.results.length > 0 &&
								searchResults.results[activeResultGroup].map((item, idx) => (
									<ResultItem
										headline={item.headline}
										url={item.url}
										text={item.description}
										key={idx}
									/>
								))}
							{searchResults.results.length === 0 && (
								<StyledSearchResults.NoResults>
									<StyledSearchResults.NoResultsText>
										{t('search-no-results')}
									</StyledSearchResults.NoResultsText>
								</StyledSearchResults.NoResults>
							)}
						</StyledSearchResults.ResultItems>
					</StyledSearchResults.ResultsWrapper>
					{searchResults.results.length > 0 && (
						<Pagination
							numberOfGroups={searchResults.resultsGroups}
							onChange={val => setActiveResultgroup(val)}
						/>
					)}
				</>
			)}
		</StyledSearchResults.Wrapper>
	);
};

export default SearchResults;
